/**
 * 集成模块 key
 */
export default {
    /* 聊天插件 start */
    I_P_R: '集成-聊天插件',
    I_P_C: '创建插件',
    // 回收站
    I_P_R_B: '回收站',
    I_P_R_B_0: '回收站_恢复', // 特殊属性：addition: { id: '1' // 插件id }
    // 批量操作
    I_P_B: '批量操作', // 采集时机：多选后，鼠标移入
    I_P_B_0: '批量_配置客服',
    I_P_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_P_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_P_B_1: '批量_备注',
    I_P_B_1_0: '批量_备注_保存', // 特殊属性：addition: { ids: string }
    I_P_B_1_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_P_B_2: '批量_回收',
    I_P_B_2_0: '批量_回收_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_P_B_2_1: '批量_回收_取消', // 采集时机：点击取消按钮

    I_P_P_V: '预览',
    I_P_E_P: '编辑插件',

    // 编辑自动化
    I_P_E_F: '编辑自动化',
    I_P_E_F_0: '编辑自动化_确定',
    I_P_E_F_1: '编辑自动化_取消',

    // 专属链接
    I_P_E_L: '专属链接',
    I_P_E_L_0: '专属链接_复制链接',
    I_P_E_L_1: '专属链接_保存',
    I_P_E_L_1_0: '专属链接_保存_成功',
    I_P_E_L_1_1: '专属链接_保存_失败',
    I_P_E_L_2: '专属链接_更换',
    I_P_E_L_3: '专属链接_验证连接',
    I_P_E_L_3_0: '专属链接_验证连接_成功',
    I_P_E_L_3_1: '专属链接_验证连接_失败',

    // 配置客服
    I_P_C_C: '配置客服',
    I_P_C_C_0: '配置客服_确定',
    I_P_C_C_1: '配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时

    // 备注
    I_P_R_M: '备注',
    I_P_R_M_0: '备注_保存',
    I_P_R_M_1: '备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时

    // 插件状态
    I_P_S_0: '插件状态_开启',
    I_P_S_1: '插件状态_关闭',
    I_P_C_I: '复制安装代码',

    // 集成站点
    I_P_I_S: '集成站点',
    I_P_I_S_0: '授权shopify',
    I_P_I_S_1: '授权shoplazza',
    I_P_I_S_2: '授权shopyy',
    I_P_I_S_3: '授权shopline',
    I_P_I_S_4: '授权meshop',
    I_P_I_S_5: '授权wordpress',
    I_P_I_S_6: '授权opencart',
    I_P_I_S_7: '授权shoptop',
    I_P_I_S_8: '授权oemsaas',
    I_P_I_S_9: '授权BigCommerce',
    I_P_I_S_10: '授权UEESHOP',
    I_P_I_S_11: '授权其他',
    /* 聊天插件 end */

    /* 集成-Fackbook-主页 start */
    // 授权Facebook账号
    I_F_P_R: '集成-Fackbook-主页',
    I_F_P_A_A: '授权Facebook账号',
    I_F_P_A_A_0: '添加Facebook账号_成功', // 采集方式：跳转到授权成功中转页
    I_F_P_A_A_1: '添加Facebook账号_失败', // 采集方式：跳转到授权失败中转页

    I_F_P_C_L: '复制授权链接',
    I_F_P_G_A: '获取主页API',

    // 同步自动化
    I_F_P_S_F: '同步自动化',
    I_F_P_S_F_0: '同步自动化_确定',
    I_F_P_S_F_1: '同步自动化_取消',

    // 同步记录
    I_F_P_S_R: '同步记录',
    I_F_P_S_R_0: '同步记录_取消同步',
    I_F_P_S_R_1: '同步记录_生成会话',
    I_F_P_S_R_2: '同步记录_生成会话_立即生成', // 特殊属性：addition: { type: '0',  // 生成会话类型 【生成会话类型：0-主页未回复的历史会话 1-全部历史会话】}

    I_F_P_S_A: '选择Facebook帐号', // 采集时机：点击筛选Facebook帐号，清除筛选不算；特殊属性：addition: { ids: string }

    // 批量操作
    I_F_P_B: '批量操作', // 采集时机：鼠标移入
    I_F_P_B_0: '批量_配置客服',
    I_F_P_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_F_P_B_1: '批量_设置欢迎语',
    I_F_P_B_1_0: '批量_设置欢迎语_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_1_1: '批量_设置欢迎语_创建自动化',
    I_F_P_B_1_2: '批量_设置欢迎语_取消',
    I_F_P_B_2: '批量_编辑Messenger自动化',
    I_F_P_B_2_0: '批量_编辑Messenger自动化_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_2_1: '批量_编辑Messenger自动化_取消',
    I_F_P_B_3: '批量_编辑帖子评论自动化',
    I_F_P_B_3_0: '批量_编辑帖子评论自动化_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_3_1: '批量_编辑帖子评论自动化_取消',
    I_F_P_B_4: '批量_启用/停用Messenger',
    I_F_P_B_4_0: '批量_启用/停用Messenger_确定', // 特殊属性：addition: { ids: string, status: '1/0' }
    I_F_P_B_4_1: '批量_启用/停用Messenger_取消',
    I_F_P_B_5: '批量_启用/停用帖子评论',
    I_F_P_B_5_0: '批量_启用/停用帖子评论_确定', // 特殊属性：addition: { ids: string, status: '1/0' }
    I_F_P_B_5_1: '批量_启用/停用帖子评论_取消',
    I_F_P_B_6: '批量_备注',
    I_F_P_B_6_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_6_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_F_P_B_7: '批量_删除主页',
    I_F_P_B_7_0: '批量_删除主页_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_F_P_B_7_1: '批量_删除主页_取消', // 采集时机：点击取消按钮

    I_F_P_E_M: '导出最近最大数量',
    I_F_P_E_A: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量 is_all: true, // 是否全选 }

    I_F_P_S_0: 'Messenger状态_开启',
    I_F_P_S_1: 'Messenger状态_关闭',
    I_F_P_S_2: '帖子评论状态_启用',
    I_F_P_S_3: '帖子评论状态_关闭',

    // 配置客服
    I_F_P_C_C: '配置客服',
    I_F_P_C_C_0: '配置客服_确定',
    I_F_P_C_C_1: '配置客服_取消',

    // 设置欢迎语
    I_F_P_S_W: '设置欢迎语',
    I_F_P_S_W_0: '设置欢迎语_确定',
    I_F_P_S_W_1: '设置欢迎语_取消',

    // 编辑自动化
    I_F_P_E_F: '编辑自动化',
    I_F_P_E_F_0: '编辑自动化_确定',
    I_F_P_E_F_1: '编辑自动化_取消',

    I_F_P_S_C: '同步联系人',

    // 生成会话
    I_F_P_C_S: '生成会话',
    I_F_P_C_S_0: '生成会话_立即生成', // 特殊属性：addition: { type: '0',  // 生成会话类型 【生成会话类型：0-主页未回复的历史会话 1-全部历史会话】}

    I_F_P_S_L: '同步标签',

    // 备注
    I_F_P_R_M: '备注',
    I_F_P_R_M_0: '备注_保存',
    I_F_P_R_M_1: '备注_取消',
    /* 集成-Fackbook-主页 end */

    /* 集成-Fackbook-账号 start */
    I_F_A_R: '集成-Fackbook-账号',
    I_F_A_A_A: '授权Facebook账号',
    I_F_A_C_L: '复制授权链接',
    I_F_A_G_A: '获取主页API',

    // 删除账号
    I_F_A_D_A: '删除账号',
    I_F_A_D_A_0: '删除账号_确认', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    /* 集成-Fackbook-账号 end */

    /* 微信客服 start */
    I_X_R: '集成-微信客服',
    I_X_A_D: '授权企业微信账号',
    I_X_A_D_0: '授权企业微信账号_成功',
    I_X_A_D_1: '授权企业微信账号_失败',

    I_X_P_Z: '授权配置',
    I_X_P_Z_0: '授权配置_解除授权',
    I_X_P_Z_0_0: '授权配置_解除授权_前往企微',

    I_X_A_K: '新建客服账号',
    I_X_A_K_0: '新建客服账号_确定',
    I_X_A_K_1: '新建客服账号_取消',

    I_X_T_B: '同步',

    I_X_C_B: '批量操作',
    I_X_C_B_0: '批量_配置客服',
    I_X_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_X_C_B_0_1: '批量_配置客服_取消',
    I_X_C_B_1: '批量_备注',
    I_X_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_X_C_B_1_1: '批量_备注_取消',
    I_X_C_B_2: '批量_删除',
    I_X_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_X_C_B_2_1: '批量_删除_取消',

    I_X_Z_Y: '账号状态_开启',
    I_X_Z_N: '账号状态_关闭',

    I_X_G_L: '获取链接',

    I_X_B_J: '编辑',
    I_X_B_J_0: '编辑_确定',
    I_X_B_J_1: '编辑_取消',

    I_X_P_K: '配置客服',
    I_X_P_K_0: '配置客服_确定',
    I_X_P_K_1: '配置客服_取消',

    I_X_B_Z: '备注',
    I_X_B_Z_0: '备注_保存',
    I_X_B_Z_1: '备注_取消',
    /* 微信客服 end */

    /* Slack start */
    I_S_R: '集成-Slack',
    I_S_A_D: '授权账号',

    I_S_C_B: '批量操作',
    I_S_C_B_0: '批量_配置客服',
    I_S_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_S_C_B_0_1: '批量_配置客服_取消',
    I_S_C_B_1: '批量_备注',
    I_S_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_S_C_B_1_1: '批量_备注_取消',
    I_S_C_B_2: '批量_删除',
    I_S_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_S_C_B_2_1: '批量_删除_取消',

    I_S_Z_Y: '账号状态_开启',
    I_S_Z_N: '账号状态_关闭',

    I_S_E_Z: '编辑自动化',
    I_S_E_Z_0: '编辑自动化_确定',
    I_S_E_Z_1: '编辑自动化_取消',

    I_S_P_K: '配置客服',
    I_S_P_K_0: '配置客服_确定',
    I_S_P_K_1: '配置客服_取消',

    I_S_B_Z: '备注',
    I_S_B_Z_0: '备注_保存',
    I_S_B_Z_1: '备注_取消',
    /* Slack end */

    /* VKontakte start */
    I_V_R: '集成-VKontakte',
    I_V_A_D: '添加社区',
    I_V_A_D_0: '添加社区_确定',
    I_V_A_D_0_1: '添加社区_确定_成功',
    I_V_A_D_0_2: '添加社区_确定_失败',
    I_V_A_D_1: '添加社区_取消',

    I_V_C_B: '批量操作',
    I_V_C_B_0: '批量_配置客服',
    I_V_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_V_C_B_0_1: '批量_配置客服_取消',
    I_V_C_B_1: '批量_备注',
    I_V_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_V_C_B_1_1: '批量_备注_取消',
    I_V_C_B_2: '批量_删除',
    I_V_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_V_C_B_2_1: '批量_删除_取消',

    I_V_Z_Y: '账号状态_开启',
    I_V_Z_N: '账号状态_关闭',

    I_V_P_K: '配置客服',
    I_V_P_K_0: '配置客服_确定',
    I_V_P_K_1: '配置客服_取消',

    I_V_B_Z: '备注',
    I_V_B_Z_0: '备注_保存',
    I_V_B_Z_1: '备注_取消',
    /* VKontakte end */

    /* Tiktok商业号 start */
    I_B_R: '集成-TikTok-商业号',
    I_B_A_D: '添加账号',
    I_B_A_D_0: '添加账号_成功',
    I_B_A_D_1: '添加账号_失败',

    I_B_A_A_0: '添加Tiktok广告账号_成功', // 采集方式：跳转到授权成功中转页
    I_B_A_A_1: '添加Tiktok广告账号_失败', // 采集方式：跳转到授权失败中转页

    I_B_C_B: '批量操作',
    I_B_C_B_0: '批量_配置客服',
    I_B_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_B_C_B_0_1: '批量_配置客服_取消',
    I_B_C_B_1: '批量_备注',
    I_B_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_B_C_B_1_1: '批量_备注_取消',
    I_B_C_B_2: '批量_删除',
    I_B_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_B_C_B_2_1: '批量_删除_取消',

    I_B_P_Y: '私信状态_开启',
    I_B_P_N: '私信状态_关闭',

    I_B_C_Y: '评论状态_开启',
    I_B_C_N: '评论状态_关闭',

    I_B_E_Z: '编辑自动化',
    I_B_E_Z_0: '编辑自动化_确定',
    I_B_E_Z_1: '编辑自动化_取消',

    I_B_P_K: '配置客服',
    I_B_P_K_0: '配置客服_确定',
    I_B_P_K_1: '配置客服_取消',

    I_B_B_Z: '备注',
    I_B_B_Z_0: '备注_保存',
    I_B_B_Z_1: '备注_取消',
    /* Tiktok商业号 end */

    /* WhatsApp云托管号 start */
    I_W_R: '集成-WhatsApp App',
    I_W_A_D: '添加设备',
    I_W_A_D_0: '添加设备_确定',
    I_W_A_D_0_1: '添加设备_连接成功', // 特殊属性：addition：{ way: '1', // 连接方式 0-扫码关联，1-验证码关联}
    I_W_A_D_0_2: '添加设备_关闭连接',
    I_W_A_D_0_3: '添加设备_切换关联方式', // 特殊属性：addition：{ way: '1', // }
    I_W_A_D_0_4: '添加设备_第三方',
    I_W_A_D_0_5: '添加设备_批量第三方',
    I_W_A_D_1: '添加设备_取消',

    I_W_C_B: '批量操作',
    I_W_C_B_0: '批量_配置客服',
    I_W_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_C_B_0_1: '批量_配置客服_取消',
    I_W_C_B_1: '批量_备注',
    I_W_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_C_B_1_1: '批量_备注_取消',
    I_W_C_B_2: '批量_删除',
    I_W_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_C_B_2_1: '批量_删除_取消',

    I_W_E_M: '导出最近最大数量',
    I_W_E_S: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量}

    I_W_N_C: '立即连接',
    I_W_N_C_0: '立即连接_连接成功', // 特殊属性：addition：{ way: '1', // 连接方式 0-扫码关联，1-验证码关联}
    I_W_N_C_1: '立即连接_关闭连接',
    I_W_N_C_2: '立即连接_切换关联方式', // 特殊属性：addition：{ way: '1', // 连接方式 0-扫码关联，1-验证码关联}

    I_W_S_D: '设置代理',
    I_W_S_D_0: '设置代理_确定',
    I_W_S_D_1: '设置代理_取消',

    I_W_R_C: '重新连接',
    I_W_R_C_0: '重新连接_连接成功',
    I_W_R_C_1: '重新连接_关闭连接',
    I_W_R_C_2: '重新连接_切换关联方式',

    I_W_D_C: '断开连接',
    I_W_D_C_0: '断开连接_确定',
    I_W_D_C_1: '断开连接_取消',

    I_W_E_Z: '编辑自动化',
    I_W_E_Z_0: '编辑自动化_确定',
    I_W_E_Z_1: '编辑自动化_取消',

    I_W_P_K: '配置客服',
    I_W_P_K_0: '配置客服_确定',
    I_W_P_K_1: '配置客服_取消',

    I_W_B_Z: '备注',
    I_W_B_Z_0: '备注_保存',
    I_W_B_Z_1: '备注_取消',
    /* WhatsApp云托管号 end */

    /* Telegram云托管号 start */
    I_T_R: '集成-Telegram App',
    I_T_A_D: '添加设备_验证码登录',
    I_T_A_D_0: '添加设备_确定',
    I_T_A_D_0_0: '添加设备_授权账号_添加账号信息', // 特殊属性：addition：{ is_proxy: '1'}
    I_T_A_D_0_1: '添加设备_授权账号_账号认证成功',
    I_T_A_D_0_2: '添加设备_授权账号_重新发送验证码',
    I_T_A_D_0_3: '添加设备_授权账号_取消',
    I_T_A_D_1: '添加设备_取消',

    I_T_A_D_2: '添加设备_Session连接',
    I_T_A_D_2_0: '添加设备_Session连接_成功',
    I_T_A_D_2_1: '添加设备_Session连接_取消',
    I_T_A_D_2_2: '添加设备_Session连接_上传Session文件',
    I_T_A_D_2_3: '添加设备_Session连接_未填写2FA',
    I_T_A_D_2_4: '添加设备_Session连接_已填写2FA',
    I_T_A_D_2_5: '添加设备_Session连接_下载Excel文件',
    I_T_A_D_2_6: '添加设备_Session连接_上传Excel文件',
    I_T_A_D_2_7: '添加设备_Session连接_失败',
    I_T_A_D_2_8: '添加设备_Session连接_不配置选项',
    I_T_A_D_2_9: '添加设备_Session连接_单账号配置',
    I_T_A_D_2_10: '添加设备_Session连接_多账号配置',

    I_T_C_B: '批量操作',
    I_T_C_B_0: '批量_配置客服',
    I_T_C_B_0_0: '批量_配置客服_确定',
    I_T_C_B_0_1: '批量_配置客服_取消',
    I_T_C_B_1: '批量_备注',
    I_T_C_B_1_0: '批量_备注_保存',
    I_T_C_B_1_1: '批量_备注_取消',
    I_T_C_B_2: '批量_删除',
    I_T_C_B_2_0: '批量_删除_确定',
    I_T_C_B_2_1: '批量_删除_取消',

    I_T_E_M: '导出最近最大数量',
    I_T_E_S: '导出已选',

    I_T_N_C: '立即授权',
    I_T_N_C_0: '立即授权_添加账号信息',
    I_T_N_C_1: '立即授权_账号认证成功',
    I_T_N_C_2: '立即授权_重新发送验证码',
    I_T_N_C_3: '立即授权_取消',

    I_T_L_Y: '立即验证',
    I_T_L_Y_0: '立即验证_账号验证成功',
    I_T_L_Y_1: '立即验证_重新发送验证码',
    I_T_L_Y_2: '立即验证_取消',

    I_T_R_C: '重新连接',

    I_T_D_C: '断开连接',
    I_T_D_C_0: '断开连接_确定',
    I_T_D_C_1: '断开连接_取消',

    I_T_S_D: '设置代理',
    I_T_S_D_0: '设置代理_确定', // 特殊属性：addition：{ is_proxy: '1', // 是否使用代理 1-是 0-否 }
    I_T_S_D_1: '设置代理_取消',

    I_T_E_Z: '编辑自动化',
    I_T_E_Z_0: '编辑自动化_确定',
    I_T_E_Z_1: '编辑自动化_取消',

    I_T_P_K: '配置客服',
    I_T_P_K_0: '配置客服_确定',
    I_T_P_K_1: '配置客服_取消',

    I_T_B_Z: '备注',
    I_T_B_Z_0: '备注_保存',
    I_T_B_Z_1: '备注_取消',
    /* Telegram云托管号 end */

    /* Tiktok云托管号 start */
    I_K_R: '集成-TikTok App',
    I_K_A_D: '添加设备',
    I_K_A_D_0: '添加设备_确定',
    I_K_A_D_0_1: '添加设备_登录成功',
    I_K_A_D_0_2: '添加设备_刷新二维码',
    I_K_A_D_0_3: '添加设备_取消登录',
    I_K_A_D_1: '添加设备_取消',

    I_K_C_B: '批量操作',
    I_K_C_B_0: '批量_配置客服',
    I_K_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_K_C_B_0_1: '批量_配置客服_取消',
    I_K_C_B_1: '批量_备注',
    I_K_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_K_C_B_1_1: '批量_备注_取消',
    I_K_C_B_2: '批量_删除',
    I_K_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_K_C_B_2_1: '批量_删除_取消',

    I_K_E_M: '导出最近最大数量',
    I_K_E_S: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量 }

    I_K_P_Y: '私信状态_开启',
    I_K_P_N: '私信状态_关闭',

    I_K_C_Y: '评论状态_开启',
    I_K_C_N: '评论状态_关闭',

    I_K_N_C: '立即连接',
    I_K_N_C_0: '立即连接_登录成功',
    I_K_N_C_1: '立即连接_刷新二维码',
    I_K_N_C_2: '立即连接_取消登录',

    I_K_R_C: '重新连接',
    I_K_R_C_0: '重新连接_登录成功',
    I_K_R_C_1: '重新连接_刷新二维码',
    I_K_R_C_2: '重新连接_取消登录',

    I_K_D_C: '断开连接',
    I_K_D_C_0: '断开连接_确定',
    I_K_D_C_1: '断开连接_取消',

    I_K_S_D: '设置代理',
    I_K_S_D_0: '设置代理_确定',
    I_K_S_D_1: '设置代理_取消',

    I_K_E_Z: '编辑自动化',
    I_K_E_Z_0: '编辑自动化_确定',
    I_K_E_Z_1: '编辑自动化_取消',

    I_K_P_K: '配置客服',
    I_K_P_K_0: '配置客服_确定',
    I_K_P_K_1: '配置客服_取消',

    I_K_B_Z: '备注',
    I_K_B_Z_0: '备注_保存',
    I_K_B_Z_1: '备注_取消',
    /* Tiktok云托管号 end */

    /* TelegramBot start */
    I_T_B_R_T: '集成-TelegramBot',
    I_T_B_R: '添加机器人',
    I_T_B_R_0: '添加机器人_确定',
    I_T_B_R_1: '添加机器人_取消',
    // 批量操作
    I_T_B_B: '批量操作', // 采集时机：鼠标移入
    I_T_B_B_0: '批量_配置客服',
    I_T_B_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_T_B_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_T_B_B_1: '批量_备注',
    I_T_B_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_T_B_B_1_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_T_B_B_2: '批量_删除',
    I_T_B_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_T_B_B_2_1: '批量_删除_取消', // 采集时机：点击取消按钮

    // 帐号状态
    I_T_B_S_0: '帐号状态_开启',
    I_T_B_S_1: '帐号状态_关闭',

    // 编辑自动化
    I_T_B_E_F: '编辑自动化',
    I_T_B_E_F_0: '编辑自动化_确定',
    I_T_B_E_F_1: '编辑自动化_取消',

    // 配置客服
    I_T_B_C_C: '配置客服',
    I_T_B_C_C_0: '配置客服_确定',
    I_T_B_C_C_1: '配置客服_取消',

    // 备注
    I_T_B_R_M: '备注',
    I_T_B_R_M_0: '备注_保存',
    I_T_B_R_M_1: '备注_取消',
    /* TelegramBot end */

    /* Zalo云托管号 start */
    I_Z_R: '集成-Zalo App',
    I_Z_A_D: '添加设备',
    I_Z_A_D_0: '添加设备_确定',
    I_Z_A_D_0_1: '添加设备_登录成功',
    I_Z_A_D_0_2: '添加设备_取消登录',
    I_Z_A_D_0_3: '添加设备_刷新二维码',
    I_Z_A_D_1: '添加设备_取消',

    I_Z_C_B: '批量操作',
    I_Z_C_B_0: '批量_配置客服',
    I_Z_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Z_C_B_0_1: '批量_配置客服_取消',
    I_Z_C_B_1: '批量_备注',
    I_Z_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Z_C_B_1_1: '批量_备注_取消',
    I_Z_C_B_2: '批量_删除',
    I_Z_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Z_C_B_2_1: '批量_删除_取消',

    I_Z_N_C: '立即连接',
    I_Z_N_C_0: '立即连接_登录成功',
    I_Z_N_C_1: '立即连接_取消登录',
    I_Z_N_C_2: '立即连接_刷新二维码',

    I_Z_R_C: '重新连接',
    I_Z_R_C_0: '重新连接_登录成功',
    I_Z_R_C_1: '重新连接_取消登录',
    I_Z_R_C_2: '重新连接_刷新二维码',

    I_Z_D_C: '断开连接',
    I_Z_D_C_0: '断开连接_确定',
    I_Z_D_C_1: '断开连接_取消',

    I_Z_S_D: '设置代理',
    I_Z_S_D_0: '设置代理_确定',
    I_Z_S_D_1: '设置代理_取消',

    I_Z_E_Z: '编辑自动化',
    I_Z_E_Z_0: '编辑自动化_确定',
    I_Z_E_Z_1: '编辑自动化_取消',

    I_Z_P_K: '配置客服',
    I_Z_P_K_0: '配置客服_确定',
    I_Z_P_K_1: '配置客服_取消',

    I_Z_B_Z: '备注',
    I_Z_B_Z_0: '备注_保存',
    I_Z_B_Z_1: '备注_取消',
    /* Zalo云托管号 end */

    /* LINE云托管号 start */
    I_L_A_R: '集成-LINE App',
    I_L_A_A_D: '添加设备',
    I_L_A_A_D_0: '添加设备_确定',
    I_L_A_A_D_0_1: '添加设备_登录成功',
    I_L_A_A_D_0_2: '添加设备_刷新二维码',
    I_L_A_A_D_0_3: '添加设备_取消登录',
    I_L_A_A_D_1: '添加设备_取消',

    I_L_A_C_B: '批量操作',
    I_L_A_C_B_0: '批量_配置客服',
    I_L_A_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_A_C_B_0_1: '批量_配置客服_取消',
    I_L_A_C_B_1: '批量_备注',
    I_L_A_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_A_C_B_1_1: '批量_备注_取消',
    I_L_A_C_B_2: '批量_删除',
    I_L_A_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_A_C_B_2_1: '批量_删除_取消',

    I_L_A_E_M: '导出最近最大数量',
    I_L_A_E_S: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量 }

    I_L_A_N_C: '立即连接',
    I_L_A_N_C_0: '立即连接_登录成功',
    I_L_A_N_C_1: '立即连接_刷新二维码',
    I_L_A_N_C_2: '立即连接_取消登录',

    I_L_A_R_C: '重新连接',
    I_L_A_R_C_0: '重新连接_登录成功',
    I_L_A_R_C_1: '重新连接_刷新二维码',
    I_L_A_R_C_2: '重新连接_取消登录',

    I_L_A_D_C: '断开连接',
    I_L_A_D_C_0: '断开连接_确定',
    I_L_A_D_C_1: '断开连接_取消',

    I_L_A_S_D: '设置代理',
    I_L_A_S_D_0: '设置代理_确定',
    I_L_A_S_D_1: '设置代理_取消',

    I_L_A_E_Z: '编辑自动化',
    I_L_A_E_Z_0: '编辑自动化_确定',
    I_L_A_E_Z_1: '编辑自动化_取消',

    I_L_A_P_K: '配置客服',
    I_L_A_P_K_0: '配置客服_确定',
    I_L_A_P_K_1: '配置客服_取消',

    I_L_A_B_Z: '备注',
    I_L_A_B_Z_0: '备注_保存',
    I_L_A_B_Z_1: '备注_取消',
    /* LINE云托管号 end */

    /* Email start */
    I_E_R: '集成-Email',
    I_E_A_E: '添加邮箱',
    I_E_A_E_0: '添加邮箱_下一步', // 特殊属性：addition: { type: 'ali_qiye'  // 邮箱类型, receive_type: '0', // 接入模式 【邮箱类型 ali_qiye-阿里企业邮箱 接入模式 0-客户端模式 1-转发模式】 }
    I_E_A_E_1: '添加邮箱_确定', // 特殊属性：addition: { type: 'ali_qiye'  // 邮箱类型, receive_type: '0', // 接入模式 【邮箱类型 ali_qiye-阿里企业邮箱 接入模式 0-客户端模式 1-转发模式】 } 注意：区分客户端模式、转发模式的下一步
    I_E_A_E_2: '添加邮箱_取消', // 采集时机：点击关闭、取消按钮

    // 批量操作
    I_E_B: '批量操作', // 采集时机：鼠标移入
    I_E_B_0: '批量_配置客服',
    I_E_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_E_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_E_B_1: '批量_备注',
    I_E_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_E_B_1_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_E_B_2: '批量_删除',
    I_E_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_E_B_2_1: '批量_删除_取消', // 采集时机：点击取消按钮

    // 邮箱状态
    I_E_S_0: '邮箱状态_开启',
    I_E_S_1: '邮箱状态_关闭',

    // 编辑
    I_E_E: '编辑',
    I_E_E_0: '编辑_下一步', // 特殊属性：addition: { receive_type: '0', // 接入模式 【接入模式 0-客户端模式 1-转发模式】 }
    I_E_E_1: '编辑_确定', // 特殊属性：addition: { receive_type: '0', // 接入模式 【接入模式 0-客户端模式 1-转发模式】 }
    I_E_E_2: '编辑_取消', // 采集时机：点击关闭、取消按钮

    // 编辑自动化
    I_E_E_F: '编辑自动化',
    I_E_E_F_0: '编辑自动化_确定',
    I_E_E_F_1: '编辑自动化_取消',

    // 配置客服
    I_E_C_C: '配置客服',
    I_E_C_C_0: '配置客服_确定',
    I_E_C_C_1: '配置客服_取消',

    // 备注
    I_E_R_M: '备注',
    I_E_R_M_0: '备注_保存',
    I_E_R_M_1: '备注_取消',
    /* Email end */

    /* Instagram&评论 start */
    I_I_R: '集成-Instagram',
    I_I_A_A: '添加Instagram账号',
    I_I_A_A_0: '添加Instagram账号_成功', // 采集方式：跳转到授权成功中转页
    I_I_A_A_1: '添加Instagram账号_失败', // 采集方式：跳转到授权失败中转页

    I_I_S_R: '同步记录',
    I_I_S_R_0: '同步记录_生成会话',
    I_I_S_R_0_0: '同步记录_生成会话_立即生成', // 特殊属性：addition: { type: '0',  // 生成会话类型 【生成会话类型：0-主页未回复的历史会话 1-全部历史会话】}

    I_I_B: '批量操作',
    I_I_B_0: '批量_配置客服',
    I_I_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_I_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_I_B_1: '批量_备注',
    I_I_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_I_B_1_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_I_B_2: '批量_删除',
    I_I_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_I_B_2_1: '批量_删除_取消', // 采集时机：点击取消按钮

    I_I_S_0: '私信状态_开启',
    I_I_S_1: '私信状态_关闭',
    I_I_S_2: '评论状态_开启',
    I_I_S_3: '评论状态_关闭',
    I_I_S_4: '刷新状态',
    I_I_S_5: '重新授权',

    // 编辑自动化
    I_I_E_F: '编辑自动化',
    I_I_E_F_0: '编辑自动化_确定',
    I_I_E_F_1: '编辑自动化_取消',

    I_I_S_C: '同步联系人',

    // 生成会话
    I_I_C_S: '生成会话',
    I_I_C_S_0: '生成会话_立即生成', // 特殊属性：addition: { type: '0',  // 生成会话类型 【生成会话类型：0-主页未回复的历史会话 1-全部历史会话】}

    // 配置客服
    I_I_C_C: '配置客服',
    I_I_C_C_0: '配置客服_确定',
    I_I_C_C_1: '配置客服_取消',

    // 备注
    I_I_R_M: '备注',
    I_I_R_M_0: '备注_保存',
    I_I_R_M_1: '备注_取消',
    /* Instagram&评论 end */

    /* Line start */
    I_L_R: '集成-LINE',
    I_L_A_A: '添加账号',
    I_L_A_A_0: '添加账号_确定',
    I_L_A_A_0_0: '添加账号_确定_成功', // 采集时机：调用接口后成功添加
    I_L_A_A_1: '添加账号_取消',

    // 批量操作
    I_L_B: '批量操作', // 采集时机：鼠标移入
    I_L_B_0: '批量_配置客服',
    I_L_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_B_0_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_L_B_1: '批量_备注',
    I_L_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_B_1_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_L_B_2: '批量_删除',
    I_L_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_L_B_2_1: '批量_删除_取消', // 采集时机：点击取消按钮

    // 帐号状态
    I_L_S_0: '帐号状态_开启',
    I_L_S_1: '帐号状态_关闭',

    // 测试消息
    I_L_T: '测试消息',
    I_L_T_0: '测试消息_前往发送',

    // 编辑自动化
    I_L_E_F: '编辑自动化',
    I_L_E_F_0: '编辑自动化_确定',
    I_L_E_F_1: '编辑自动化_取消',

    // 配置客服
    I_L_C_C: '配置客服',
    I_L_C_C_0: '配置客服_确定',
    I_L_C_C_1: '配置客服_取消',

    // 备注
    I_L_R_M: '备注',
    I_L_R_M_0: '备注_保存',
    I_L_R_M_1: '备注_取消',

    I_L_S_M: '会话设置',
    I_L_S_M_0: '会话设置_取消',
    I_L_S_M_1: '会话设置_确认',
    /* Line end */

    /* WhatsApp API-自助 start */
    I_W_A_P_R: '集成-WhatsApp API-自助',
    I_W_A_P_S_B: '自助买号',
    I_W_A_P_S_B_0: '自助买号_购买',
    I_W_A_P_S_B_0_0: '自助买号_购买_完成', // 采集时机：支付成功
    I_W_A_P_S_B_1: '自助买号_取消', // 采集时机：关闭买号弹窗

    I_W_A_P_S_R: '自助注册',
    I_W_A_P_S_R_0: '自助注册_授权', // 采集时机：点击按钮打开授权弹窗页
    I_W_A_P_S_R_0_0: '自助注册_授权_成功', // 采集时机：收到 fb sdk 成功事件 判断方式：正常收到回调
    I_W_A_P_S_R_0_1: '自助注册_授权_失败', // 采集时机：授权未完成关闭fb授权页或点击取消按钮 判断方式：window.FB.login 返回的值中 status 为 'unknown'
    I_W_A_P_S_R_1: '自助注册_取消', // 采集时机：点击弹窗右上角关闭授权弹窗

    I_W_A_P_S_A: '授权号码',

    // 回收站
    I_W_A_P_R_B: '回收站',
    I_W_A_P_R_B_0: '回收站_恢复', // 特殊属性：addition: { id: '1' // 插件id }

    I_W_A_P_S: '同步',
    I_W_A_P_T_R: '转移记录',

    I_W_A_P_H: '刷新',

    // 批量操作
    I_W_A_P_B: '批量操作', // 采集时机：鼠标移入
    I_W_A_P_B_0: '批量_启用/停用帐号',
    I_W_A_P_B_0_0: '批量_启用/停用帐号_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id status: '1', // 状态 1-启用 0-停用 }
    I_W_A_P_B_0_1: '批量_启用/停用帐号_取消',
    I_W_A_P_B_1: '批量_配置客服',
    I_W_A_P_B_1_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_P_B_1_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_W_A_P_B_2: '批量_备注',
    I_W_A_P_B_2_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_P_B_2_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_W_A_P_B_3: '批量_回收',
    I_W_A_P_B_3_0: '批量_回收_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_P_B_3_1: '批量_回收_取消', // 采集时机：点击取消按钮

    I_W_A_P_E_M: '导出最近最大数量',
    I_W_A_P_E_A: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量 is_all: true, // 是否全选 }
    I_W_A_P_P_C: '价格计算器',
    I_W_A_P_B_D: '账单明细',
    I_W_A_P_R_C: '充值',

    // 帐号状态
    I_W_A_P_0: '帐号状态_开启',
    I_W_A_P_1: '帐号状态_关闭',

    // 编辑自动化
    I_W_A_P_E_F: '编辑自动化',
    I_W_A_P_E_F_0: '编辑自动化_确定',
    I_W_A_P_E_F_1: '编辑自动化_取消',

    // 修改资料
    I_W_A_P_E_I: '修改资料',
    I_W_A_P_E_I_0: '修改资料_确定',
    I_W_A_P_E_I_1: '修改资料_取消',

    // 迁移联系人
    I_W_A_P_T_C: '迁移联系人',
    I_W_A_P_T_C_0: '迁移联系人_确定', // 采集时机：二次确认后采集
    I_W_A_P_T_C_1: '迁移联系人_取消',

    // 测试消息
    I_W_A_P_T: '测试消息',
    I_W_A_P_T_0: '测试消息_前往发送',

    // 配置客服
    I_W_A_P_C_C: '配置客服',
    I_W_A_P_C_C_0: '配置客服_确定',
    I_W_A_P_C_C_1: '配置客服_取消',

    // 备注
    I_W_A_P_R_M: '备注',
    I_W_A_P_R_M_0: '备注_保存',
    I_W_A_P_R_M_1: '备注_取消',

    // 转移
    I_W_A_P_C: '转移',
    I_W_A_P_C_0: '转移_确定',
    I_W_A_P_C_1: '转移_取消',
    /* WhatsApp API-自助 end */

    /* 集成-WhatsApp API-第三方 start */
    I_W_A_T_R: '集成-WhatsApp API-第三方',
    I_W_A_T_T_R: '第三方注册',
    I_W_A_T_T_R_0: '第三方注册_授权', // 采集时机：点击按钮打开授权弹窗页
    I_W_A_T_T_R_0_0: '第三方注册_授权_成功', // 采集时机：收到 fb sdk 成功事件 判断方式：正常收到回调
    I_W_A_T_T_R_0_1: '第三方注册_授权_失败', // 采集时机：授权未完成关闭fb授权页或点击取消按钮 判断方式：window.FB.login 返回的值中 status 为 'unknown'
    I_W_A_T_T_R_1: '自助注册_取消', // 采集时机：点击弹窗右上角关闭授权弹窗

    I_W_A_T_T_A: '第三方接入', // 采集时机：1、添加号码-接入第三方API号码 2、第三方管理-添加key
    I_W_A_T_T_A_0: '第三方接入_确定',
    I_W_A_T_T_A_0_0: '第三方接入_确定_成功', // 采集时机：接口回调成功
    I_W_A_T_T_A_0_1: '第三方接入_确定_失败', // 采集时机：接口回调失败
    I_W_A_T_T_A_1: '第三方接入_取消',

    // 第三方管理
    I_W_A_T_T_M: '第三方管理',
    I_W_A_T_T_M_0: '第三方管理_编辑',
    I_W_A_T_T_M_1: '第三方管理_同步',
    I_W_A_T_T_M_2: '第三方管理_转移',
    I_W_A_T_T_M_2_0: '第三方管理_转移_确定',
    I_W_A_T_T_M_2_1: '第三方管理_转移_取消',
    I_W_A_T_T_M_3: '第三方管理_删除',
    I_W_A_T_T_M_3_0: '第三方管理_删除_确定',
    I_W_A_T_T_M_3_1: '第三方管理_删除_取消',

    I_W_A_T_S: '同步',

    // 批量操作
    I_W_A_T_B: '批量操作', // 采集时机：鼠标移入
    I_W_A_T_B_0: '批量_启用/停用帐号',
    I_W_A_T_B_0_0: '批量_启用/停用帐号_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id status: '1', // 状态 1-启用 0-停用 }
    I_W_A_T_B_0_1: '批量_启用/停用帐号_取消',
    I_W_A_T_B_1: '批量_配置客服',
    I_W_A_T_B_1_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_T_B_1_1: '批量_配置客服_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_W_A_T_B_2: '批量_备注',
    I_W_A_T_B_2_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_T_B_2_1: '批量_备注_取消', // 采集时机：点击取消、关闭按钮，点击其他区域收起弹窗时
    I_W_A_T_B_3: '批量_删除',
    I_W_A_T_B_3_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_A_T_B_3_1: '批量_删除_取消', // 采集时机：点击取消按钮

    I_W_A_T_E_M: '导出最近最大数量',
    I_W_A_T_E_A: '导出已选', // 特殊属性：addition：{ total: number, // 选中数量 is_all: true, // 是否全选 }

    // 帐号状态
    I_W_A_T_0: '帐号状态_开启',
    I_W_A_T_1: '帐号状态_关闭',

    // 编辑自动化
    I_W_A_T_E_F: '编辑自动化',
    I_W_A_T_E_F_0: '编辑自动化_确定',
    I_W_A_T_E_F_1: '编辑自动化_取消',

    // 修改资料
    I_W_A_T_E_I: '修改资料',
    I_W_A_T_E_I_0: '修改资料_确定',
    I_W_A_T_E_I_1: '修改资料_取消',

    // 迁移联系人
    I_W_A_T_T_C: '迁移联系人',
    I_W_A_T_T_C_0: '迁移联系人_确定', // 采集时机：二次确认后采集
    I_W_A_T_T_C_1: '迁移联系人_取消',

    // 测试消息
    I_W_A_T_T: '测试消息',
    I_W_A_T_T_0: '测试消息_前往发送',

    // 配置客服
    I_W_A_T_C_C: '配置客服',
    I_W_A_T_C_C_0: '配置客服_确定',
    I_W_A_T_C_C_1: '配置客服_取消',

    // 备注
    I_W_A_T_R_M: '备注',
    I_W_A_T_R_M_0: '备注_保存',
    I_W_A_T_R_M_1: '备注_取消',

    // 点击授权MML
    I_W_A_T_A_M: '点击授权MML',

    // 费用明细
    I_W_A_T_C_B: '费用明细',
    /* 集成-WhatsApp API-第三方 end */

    /* 企业微信 start */
    I_W_B_R: '集成-企业微信',
    I_W_B_A: '添加企业微信',
    I_W_B_A_0: '添加企业微信_确定',
    I_W_B_A_0_0: '添加企业微信_确定_成功',
    I_W_B_A_0_1: '添加企业微信_确定_失败',
    I_W_B_A_1: '添加企业微信_取消',

    I_W_B_B: '批量操作',
    I_W_B_B_0: '批量_配置客服',
    I_W_B_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_B_B_0_1: '批量_配置客服_取消',
    I_W_B_B_1: '批量_备注',
    I_W_B_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_B_B_1_1: '批量_备注_取消',
    I_W_B_B_2: '批量_删除',
    I_W_B_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_B_B_2_1: '批量_删除_取消',
    I_W_B_B_3: '批量_刷新状态', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }

    I_W_B_Y: '帐号状态_开启',
    I_W_B_N: '帐号状态_关闭',

    I_W_B_E_Z: '编辑自动化',
    I_W_B_E_Z_0: '编辑自动化_确定',
    I_W_B_E_Z_1: '编辑自动化_取消',

    I_W_B_P_K: '配置客服',
    I_W_B_P_K_0: '配置客服_确定',
    I_W_B_P_K_1: '配置客服_取消',

    I_W_B_B_Z: '备注',
    I_W_B_B_Z_0: '备注_保存',
    I_W_B_B_Z_1: '备注_取消',

    I_W_B_T_C: '迁移联系人',
    I_W_B_T_C_0: '迁移联系人_确定', // 采集时机：二次确认后采集
    I_W_B_T_C_1: '迁移联系人_取消',

    I_W_B_S_C: '同步联系人',

    I_W_B_C_D: '更换设备ID',
    I_W_B_C_D_0: '更换设备ID_更换',
    I_W_B_C_D_1: '更换设备ID_取消',

    I_W_B_R_S: '刷新状态',
    /* 企业微信 end */

    /* Youtube start */
    I_Y_R: '集成-YouTube',
    I_Y_A_A: '授权Youtube账号',
    I_Y_A_A_0: '添加Youtube账号_成功', // 采集方式：跳转到授权成功中转页
    I_Y_A_A_1: '添加Youtube账号_失败', // 采集方式：跳转到授权失败中转页

    I_Y_C_B: '批量操作',
    I_Y_C_B_0: '批量_配置客服',
    I_Y_C_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Y_C_B_0_1: '批量_配置客服_取消',
    I_Y_C_B_1: '批量_备注',
    I_Y_C_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Y_C_B_1_1: '批量_备注_取消',
    I_Y_C_B_2: '批量_删除',
    I_Y_C_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_Y_C_B_2_1: '批量_删除_取消',

    I_Y_Z_Y: '启用评论_开启',
    I_Y_Z_N: '启用评论_关闭',

    I_Y_E_Z: '编辑自动化',
    I_Y_E_Z_0: '编辑自动化_确定',
    I_Y_E_Z_1: '编辑自动化_取消',

    I_Y_P_K: '配置客服',
    I_Y_P_K_0: '配置客服_确定',
    I_Y_P_K_1: '配置客服_取消',

    I_Y_B_Z: '备注',
    I_Y_B_Z_0: '备注_保存',
    I_Y_B_Z_1: '备注_取消',
    /* Youtube end */

    /* 微信 start */
    I_W_E_R: '集成-微信',
    I_W_E_A: '添加微信',
    I_W_E_A_0: '添加微信_确定',
    I_W_E_A_0_0: '添加微信_确定_成功',
    I_W_E_A_0_1: '添加微信_确定_失败',
    I_W_E_A_1: '添加微信_取消',

    I_W_E_B: '批量操作',
    I_W_E_B_0: '批量_配置客服',
    I_W_E_B_0_0: '批量_配置客服_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_E_B_0_1: '批量_配置客服_取消',
    I_W_E_B_1: '批量_备注',
    I_W_E_B_1_0: '批量_备注_保存', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_E_B_1_1: '批量_备注_取消',
    I_W_E_B_2: '批量_删除',
    I_W_E_B_2_0: '批量_删除_确定', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }
    I_W_E_B_2_1: '批量_删除_取消',
    I_W_E_B_3: '批量_刷新状态', // 特殊属性：addition：{ ids: '1', // 选中的渠道id }

    I_W_E_Y: '帐号状态_开启',
    I_W_E_N: '帐号状态_关闭',

    I_W_E_E_Z: '编辑自动化',
    I_W_E_E_Z_0: '编辑自动化_确定',
    I_W_E_E_Z_1: '编辑自动化_取消',

    I_W_E_P_K: '配置客服',
    I_W_E_P_K_0: '配置客服_确定',
    I_W_E_P_K_1: '配置客服_取消',

    I_W_E_B_Z: '备注',
    I_W_E_B_Z_0: '备注_保存',
    I_W_E_B_Z_1: '备注_取消',

    I_W_E_T_C: '迁移联系人',
    I_W_E_T_C_0: '迁移联系人_确定', // 采集时机：二次确认后采集
    I_W_E_T_C_1: '迁移联系人_取消',

    I_W_E_S_C: '同步联系人',

    I_W_E_C_D: '更换设备ID',
    I_W_E_C_D_0: '更换设备ID_更换',
    I_W_E_C_D_1: '更换设备ID_取消',

    I_W_E_R_S: '刷新状态',
    /* 微信 end */
};
